import { Box, FormControlLabel } from "@mui/material";
import { useEffect, useState } from "react";
import TextField from '@mui/material/TextField';
import {
  Card,
  CardContent,
  CardHeader,
  Divider,
  FormControl,
  FormHelperText,
  Stack,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Checkbox,
  ButtonGroup
} from "@mui/material";
import Swal from "sweetalert2";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import React from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import { useUserDetails } from "../../../../context/auth";
import BASEURL from "../../../Utils/Baseurl";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import MaterialTypography from "../../../../components/MaterialTypography";
import MaterialButton from "../../../../components/MaterialButton";
import MaterialBox from "../../../../components/MaterialBox";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import { benefitsOptions, characteristics, reason2Options, reasonOptions, ratings } from "../exitFormData";
import { deleteExitInterviewQuery, fetchExitInterviewById, updateExitForm } from "../GraphQl";
const tableStyles = {
  table: {
    borderCollapse: "collapse",
    width: "100%", // Increased width
    margin: "0 auto", // Center the table
    // boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
    borderRadius: "6px",
    "& th, & td": {
      border: "1px solid #ddd",
      textAlign: "center",
      padding: "6px 20px", // Reduced padding for lower height
    },
    "& th": {
      backgroundColor: "#3F51B5d4",
      color: "#fff",
      fontWeight: "600",
      fontSize: "0.9rem",
      textTransform: "uppercase",
    },
    "& td": {
      fontSize: "0.85rem",
    },
    "& tr:hover td": {
      // backgroundColor: "#f3f3f3",
    },
  },
};

const AddExitForm = () => {

  const user = JSON.parse(sessionStorage.getItem("user"));
  const params = useLocation();
  const ID = params.search.slice(4);
  const navigate = useNavigate();
  const {AccessData} = useUserDetails()  
  const [id, setId] = useState(null);
  
  const [exitFormData, setExitFormData] = useState({
    exitReason: "",
    othersExitReason: "",
    othersExitReasonStatus: "unchecked",
    newJobReason: "",
    newJobReasonStatus: "unchecked",
    othersNewJobReason: "",
    othersNewJobReasonStatus: "unchecked",

    //Table comments 
    performanceReviews: "",
    opportunityForAdvancement: "",
    trainingReceived: "",
    responsibilities: "",
    workingHours: "",
    communicationSupportByManagement: "",
    companyPoliciesAndPractices: "",
    workload: "",
    salary: "",
    benefits: "",

    //Post Table Form
    additionalBenefits: "",         additionalBenefitsStatus: "unchecked",
    additionalBenefitsComments: "", additionalBenefitsCommentsStatus: "unchecked",
    managerFeedback: "",            managerFeedbackStatus: "unchecked",
    managerFeedbackComments: "",    managerFeedbackCommentsStatus: "unchecked", //Radio
    jobResponsibilities: "",        jobResponsibilitiesStatus: "unchecked",
    jobOpinion: "",                 jobOpinionStatus: "unchecked",
    frustrations: "",               frustrationsStatus: "unchecked",
    willingToStay: "",              willingToStayStatus: "unchecked",
    suggestedChanges: "",           suggestedChangesStatus: "unchecked",
    recommendCompany: "",           recommendCompanyStatus: "unchecked",
    overallComments: "",            overallCommentsStatus: "unchecked",
  });
  
  const [selectedRatings, setSelectedRatings] = useState({});  
  const ratingValues = {
    Poor: 1,
    Fair: 2,
    Good: 3,
    Excellent: 4,
  };
  // if(
  //   AccessData &&
  //   Array.isArray(AccessData) &&
  //   AccessData.some(
  //     (item) => item.component
  //   )
  // )

  const handlefeedbback = (event) => {
    const { name, value } = event.target;

    setSelectedRatings((prev) => ({
      ...prev,
      [name]: ratingValues[value],
    }));
  };

  const [togglePage, setTogglePage] = useState({
    view: false,
    edit: false,
  });

  const [pageState, setPageState] = useState({
    loading: false,
    error: false,
    message: "",
    state: "init",
  });

  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  //UseEffect to Fetch Data By ID
  useEffect(() => {
    const queryParams = new URLSearchParams(window.location.search);
    const id = queryParams.get("id");
    
    setId(id);
    if (id) {
      getInitData(id);
    }
  }, []);

//Fetch Data By ID
  const getInitData = async (id) => {
    const parseRatingValue = (val) => {
      if (!val) return null;
      const parts = val.split('_');
      return parseInt(parts[1], 10); // e.g., "A_4" -> 4
    };
    setTogglePage({
      view: true,
      edit: false,
    });
    try {
      const response = await axios.post(
        BASEURL,
        {
          query: fetchExitInterviewById,
          variables: { id },
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );
      const responseData = response.data.data.getExitInterviewById;
      setExitFormData({
        exitReason: {value: responseData.exitReason, label:responseData.exitReason},
        othersExitReason: responseData.othersExitReason,
        newJobReason: {value: responseData.newJobReason, label:responseData.newJobReason},
        othersNewJobReason: responseData.othersNewJobReason,
        performanceReviews: responseData.performanceReviewsComments,
        opportunityForAdvancement: responseData.opportunityForAdvancementComments,
        trainingReceived: responseData.trainingReceivedComments,
        companyPoliciesAndPractices: responseData.companyPoliciesComments,
        responsibilities: responseData.responsibilitiesComments,
        workingHours: responseData.workingHoursComments,
        communicationSupportByManagement: responseData.supportByManagementComments,
        workload: responseData.workloadComments,
        salary: responseData.salaryComments,
        benefits: responseData.benefitsComments,
        additionalBenefits: {value: responseData.additionalBenefits, label: responseData.additionalBenefits},
        additionalBenefitsComments: responseData.additionalBenefitsComments,
        managerFeedback: responseData.managerFeedback,
        managerFeedbackComments: responseData.managerFeedbackComments,
        jobResponsibilities: responseData.jobResponsibilities,
        jobOpinion: responseData.jobOpinion,
        frustrations: responseData.frustrations,
        willingToStay: responseData.willingToStay,
        suggestedChanges: responseData.suggestedChanges,
        recommendCompany: responseData.recommendCompany,
        overallComments: responseData.overallComments,

        //status set
        exitReasonStatus: "success",
        othersExitReasonStatus: "success",
        newJobReasonStatus: "success",
        othersNewJobReasonStatus: "success",
        additionalBenefitsStatus: "success",
        additionalBenefitsCommentsStatus: "success",
        managerFeedbackStatus: "success",
        jobResponsibilitiesStatus: "success",
        frustrationsStatus: "success",
        suggestedChangesStatus: "success",
        overallCommentsStatus: "success"
      });
      setSelectedRatings({

        performanceReviews: parseRatingValue(responseData.performanceReviews),
        opportunityForAdvancement: parseRatingValue(responseData.opportunityForAdvancement),
        trainingReceived: parseRatingValue(responseData.trainingReceived),
        companyPoliciesAndPractices: parseRatingValue(responseData.companyPolicies),
        responsibilities: parseRatingValue(responseData.responsibilities),
        workingHours: parseRatingValue(responseData.workingHours),
        communicationSupportByManagement: parseRatingValue(responseData.supportByManagement),
        workload: parseRatingValue(responseData.workload),
        salary : parseRatingValue(responseData.salary),
        benefits: parseRatingValue(responseData.benefits)

      })

    
    } catch (error) {
      console.error("ResponseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,

        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };


  const handleChange = (event, selectEvent) => {
    let taskStatusState = { ...exitFormData };
  //DropDown
    if (event?.target === undefined && selectEvent) {
      switch (selectEvent.name) {
        case "exitReason": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{0,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          if (event !== "Other") {
            taskStatusState["othersExitReason"] = "";
            taskStatusState["othersExitReasonStatus"] = "unchecked";
          }
          break;
        }

        case "newJobReason": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{0,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          if (event !== "Other") {
            taskStatusState["othersNewJobReason"] = "";
            taskStatusState["othersNewJobReasonStatus"] = "unchecked";
          }
          break;
        }
        case "additionalBenefits": {
          const alphaNLenghthRegex = new RegExp("^([A-Za-z ]{0,20})$");
          if (alphaNLenghthRegex.test(event?.trim?.())) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] =
              event === "" ? "unchecked" : "error";
          }
          if (event !== "Other") {
            taskStatusState["additionalBenefitsComments"] = "";
            taskStatusState["additionalBenefitsCommentsStatus"] = "unchecked";
          }
          break;
        }
        case "statusUpdate": {
          if (event?.value) {
            taskStatusState[selectEvent.name + "Status"] = "success";
          } else {
            taskStatusState[selectEvent.name + "Status"] = "error";
          }
          taskStatusState[selectEvent.name] = event;
          break;
        }
      }
      taskStatusState[selectEvent.name] = event;
    }
  
    else if (event && event.target) {
//Input Field
      switch (event.target.name) {
        case "othersExitReason": {
          const value = event.target.value;
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{0,100})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
        }
         
        case "othersNewJobReason": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{0,100})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 
        
        case "additionalBenefitsComments": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{0,100})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 

        case "managerFeedback": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,200})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 

        case "jobResponsibilities": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,200})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 

        case "frustrations": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,200})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 

        case "suggestedChanges": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,200})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 
        
        case "overallComments": {
          const value = event.target.value;
        
          const alphaNLenghthRegex = new RegExp("^([A-Za-z0-9 ]{1,200})$");
          if (alphaNLenghthRegex.test(value)) {
            taskStatusState[event.target.name + "Status"] = "success";
          } else {
            taskStatusState[event.target.name + "Status"] = "error";
          }
          break;
        } 
        
      }

      taskStatusState[event.target.name] = event.target.value;
    }
    setExitFormData(taskStatusState);
};

  //Create Function
  const handleAddSource = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to submit your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        handleSubmitFeedback();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
  
  //Create Mutation Function
  const handleSubmitFeedback = async () => {
    const query = `
    mutation createexitform($input:CreateExitInterviewInput!){ 
    createExitInterview(input:$input){ 
      success 
      message 
      error 
    } 
  } `;

    const alldata = {
      userId: user.id,
      exitReason: exitFormData.exitReason?.value,
      othersExitReason: exitFormData.othersExitReason,
      newJobReason: exitFormData.newJobReason?.value,
      othersNewJobReason: exitFormData.othersNewJobReason,
  
      //table rating
      performanceReviews: selectedRatings.performanceReviews,
      opportunityForAdvancement: selectedRatings.opportunityForAdvancement,
      trainingReceived: selectedRatings.trainingReceived,
      companyPolicies: selectedRatings.companyPoliciesAndPractices,
      responsibilities: selectedRatings.responsibilities,
      workingHours: selectedRatings.workingHours,
      supportByManagement: selectedRatings.communicationSupportByManagement,
      workload: selectedRatings.workload,
      salary: selectedRatings.salary,
      benefits: selectedRatings.benefits,
  
      //table comments
      performanceReviewsComments: exitFormData.performanceReviews,
      opportunityForAdvancementComments: exitFormData.opportunityForAdvancement,
      trainingReceivedComments: exitFormData.trainingReceived,
      companyPoliciesComments: exitFormData.companyPoliciesAndPractices,
      responsibilitiesComments: exitFormData.responsibilities,
      workingHoursComments: exitFormData.workingHours,
      supportByManagementComments: exitFormData.communicationSupportByManagement,
      workloadComments: exitFormData.workload,
      salaryComments: exitFormData.salary,
      benefitsComments: exitFormData.benefits,
  
      //post table payload
      additionalBenefits: exitFormData.additionalBenefits?.value,
      additionalBenefitsComments: exitFormData.additionalBenefitsComments,
      managerFeedback: exitFormData.managerFeedback,
      managerFeedbackComments: exitFormData.managerFeedbackComments,
      jobResponsibilities: exitFormData.jobResponsibilities,
      jobOpinion: exitFormData.jobOpinion,
      frustrations: exitFormData.frustrations,
      willingToStay: exitFormData.willingToStay,
      suggestedChanges: exitFormData.suggestedChanges,
      recommendCompany: exitFormData.recommendCompany,
      overallComments: exitFormData.overallComments

    };


    try {
      const response = await axios.post(BASEURL, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        query,
        variables: {
          input: alldata,
        },
      });

      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      const successStatus = response.data.data.createExitInterview.success;
      const responseMessage = response.data.data.createExitInterview.message;
      if(successStatus){
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Exit Form Submitted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/exit-form");
      }
      else{
        Swal.fire({
          position: "center",
          icon: "error",
          title: responseMessage,
          showConfirmButton: false,
          timer: 2500,
        });
      }
    } catch (error) {
      console.error("responseError:", error);
      setConfirmationDialog({
        open: true,
        title: "Error message",
        message:
          "Sorry for your inconvenience, there is some issue in our network. Please try again later.",
        showCancel: true,
        showConfirm: false,
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    }
  };

    //Update Function
    const handleEdit = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure you want to Update your details?",
        showCancel: true,
        showConfirm: true,
        onConfirm: () => {
          UpdateExitForm();
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
    };
    const aaaaaaa = {
      id: id,
      userId: user.id,
      exitReason: exitFormData.exitReason?.value,
      othersExitReason: exitFormData.othersExitReason,
      newJobReason: exitFormData.newJobReason?.value,
      othersNewJobReason: exitFormData.othersNewJobReason,
  
      // Table ratings
      performanceReviews: selectedRatings.performanceReviews,
      opportunityForAdvancement: selectedRatings.opportunityForAdvancement,
      trainingReceived: selectedRatings.trainingReceived,
      companyPolicies: selectedRatings.companyPoliciesAndPractices,
      responsibilities: selectedRatings.responsibilities,
      workingHours: selectedRatings.workingHours,
      supportByManagement: selectedRatings.communicationSupportByManagement,
      workload: selectedRatings.workload,
      salary: selectedRatings.salary,
      benefits: selectedRatings.benefits,
  
      // Table comments
      performanceReviewsComments: exitFormData.performanceReviews,
      opportunityForAdvancementComments: exitFormData.opportunityForAdvancement,
      trainingReceivedComments: exitFormData.trainingReceived,
      companyPoliciesComments: exitFormData.companyPoliciesAndPractices,
      responsibilitiesComments: exitFormData.responsibilities,
      workingHoursComments: exitFormData.workingHours,
      supportByManagementComments: exitFormData.communicationSupportByManagement,
      workloadComments: exitFormData.workload,
      salaryComments: exitFormData.salary,
      benefitsComments: exitFormData.benefits,
  
      // Additional feedback
      additionalBenefits: exitFormData.additionalBenefits?.value,
      additionalBenefitsComments: exitFormData.additionalBenefitsComments,
      managerFeedback: exitFormData.managerFeedback,
      managerFeedbackComments: exitFormData.managerFeedbackComments,
      jobResponsibilities: exitFormData.jobResponsibilities,
      jobOpinion: exitFormData.jobOpinion,
      frustrations: exitFormData.frustrations,
      willingToStay: exitFormData.willingToStay,
      suggestedChanges: exitFormData.suggestedChanges,
      recommendCompany: exitFormData.recommendCompany,
      overallComments: exitFormData.overallComments
    };
    
    //Update Mutation Function
    const UpdateExitForm = async () => {
      const alldata = {
        id: id,
        userId: user.id,
        exitReason: exitFormData.exitReason?.value,
        othersExitReason: exitFormData.othersExitReason,
        newJobReason: exitFormData.newJobReason?.value,
        othersNewJobReason: exitFormData.othersNewJobReason,
    
        // Table ratings
        performanceReviews: selectedRatings.performanceReviews,
        opportunityForAdvancement: selectedRatings.opportunityForAdvancement,
        trainingReceived: selectedRatings.trainingReceived,
        companyPolicies: selectedRatings.companyPoliciesAndPractices,
        responsibilities: selectedRatings.responsibilities,
        workingHours: selectedRatings.workingHours,
        supportByManagement: selectedRatings.communicationSupportByManagement,
        workload: selectedRatings.workload,
        salary: selectedRatings.salary,
        benefits: selectedRatings.benefits,
    
        // Table comments
        performanceReviewsComments: exitFormData.performanceReviews,
        opportunityForAdvancementComments: exitFormData.opportunityForAdvancement,
        trainingReceivedComments: exitFormData.trainingReceived,
        companyPoliciesComments: exitFormData.companyPoliciesAndPractices,
        responsibilitiesComments: exitFormData.responsibilities,
        workingHoursComments: exitFormData.workingHours,
        supportByManagementComments: exitFormData.communicationSupportByManagement,
        workloadComments: exitFormData.workload,
        salaryComments: exitFormData.salary,
        benefitsComments: exitFormData.benefits,
    
        // Additional feedback
        additionalBenefits: exitFormData.additionalBenefits?.value,
        additionalBenefitsComments: exitFormData.additionalBenefitsComments,
        managerFeedback: exitFormData.managerFeedback,
        managerFeedbackComments: exitFormData.managerFeedbackComments,
        jobResponsibilities: exitFormData.jobResponsibilities,
        jobOpinion: exitFormData.jobOpinion,
        frustrations: exitFormData.frustrations,
        willingToStay: exitFormData.willingToStay,
        suggestedChanges: exitFormData.suggestedChanges,
        recommendCompany: exitFormData.recommendCompany,
        overallComments: exitFormData.overallComments
      };      
  
      try {
        const response = await axios.post(BASEURL, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          query : updateExitForm,
          variables: {
            input: alldata,
          },
        });
  
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });        
        const successStatus = response?.data?.data?.updateExitInterview?.success;
        const responseMessage= response?.data?.data?.updateExitInterview?.message;
        if(successStatus){
          Swal.fire({
                position: "center",
                icon: "success",
                title: "Exit Form Updated Successfully!",
                showConfirmButton: false,
                timer: 2500,
              });
              navigate('/exit-form')
        }
        else{
          Swal.fire({
            position: "center",
            icon: "error",
            title: responseMessage,
            showConfirmButton: false,
            timer: 2500,
          });
        }
      } catch (error) {
        // Handle network or unexpected errors
        console.error("Network or unexpected error:", error);
        setConfirmationDialog({
          open: true,
          title: "Error message",
          message:
            "Sorry for the inconvenience, there is an issue with our network. Please try again later.",
          showCancel: true,
          showConfirm: false,
          onCancel: () => {
            setConfirmationDialog({
              ...confirmationDialog,
              open: false,
            });
          },
        });
      }
    };

  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  //Delete Function
  const AddDelete = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure do you want to Delete your details.",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDeleteStaff();
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Mutation
  const onDeleteStaff = async () => {

    try {
      const response1 = await
        axios.post(
          BASEURL,
          {
            query: deleteExitInterviewQuery,
            variables: {   id: id,},
          },
          { headers: { "Content-Type": "application/json" } }
        )
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
        Swal.fire({
          position: "center",
          icon: "success",
          title: "Exit Form Deleted Successfully!",
          showConfirmButton: false,
          timer: 2500,
        });
        navigate("/exit-form");
      
    } catch (error) {
      console.error("error:", error);
    }

  };

  const handleDiscard = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to discard your details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onDiscardWfh();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  const onDiscardWfh = () => {
    setTogglePage({
      view: true,
      edit: false,
    });

   
    setConfirmationDialog({
      ...confirmationDialog,
      open: false,
    });
  };
  const checkAllFields1 = () => {
    let allowSubmit = false;
    if (
     exitFormData.exitReasonStatus === "success" &&
     exitFormData.othersExitReasonStatus !== "error" &&
     exitFormData.newJobReasonStatus === "success" &&
     exitFormData.othersNewJobReasonStatus !== "error" &&
     //Table

     exitFormData.additionalBenefitsStatus === "success" &&
     exitFormData.additionalBenefitsCommentsStatus !== "error" &&
     exitFormData.managerFeedbackStatus === "success" &&
     exitFormData.jobResponsibilitiesStatus === "success" &&
     exitFormData.frustrationsStatus === "success" &&
     exitFormData.suggestedChangesStatus === "success" && 
     exitFormData.overallCommentsStatus === "success"

    ) {
      allowSubmit = true;
    } else {
      allowSubmit = false;
    }
    return allowSubmit;
  };

  const handlecancel = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to cancel?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        onCancelAction(); // Call the function that handles cancel
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };
 
  const onCancelAction = ()=>{
    navigate('/exit-form')
  }

  const handleCommentChange = (charKey) => (event) => {
    setExitFormData((prev) => ({
      ...prev,
      [charKey]: event.target.value,
    }));
  };
  

  
  return (
    <DashboardLayout>
      {confirmationDialog.open && (
        <ConfirmationDialog
          open={confirmationDialog.open}
          title={confirmationDialog.title}
          message={confirmationDialog.message}
          showCancel={confirmationDialog.showCancel}
          showConfirm={confirmationDialog.showConfirm}
          customSection={confirmationDialog.customSection}
          onConfirm={confirmationDialog.onConfirm}
          onCancel={confirmationDialog.onCancel}
        />
      )}
      <Card>
      <CardHeader
                  title={
                    <>
                      {togglePage.view === true || togglePage.edit === true ? (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              Edit Exit Form
                            </MaterialTypography>
                          </Stack>
                          {AccessData &&
                            Array.isArray(AccessData) &&
                            AccessData.some(
                              (item) =>
                                item.component === "EditTechnicalFeedback" &&
                                item.can_access
                            ) &&
                            togglePage.edit === true || togglePage.view === true && (
                              <ButtonGroup
                                variant="outlined"
                                aria-label="Loading button group"
                              >
                                <MaterialButton
                                  variant="gradient"
                                  color="dark"
                                  size="small"
                                  onClick={toggleEdit}
                                  startIcon={<EditIcon />}
                                >
                                  Edit
                                </MaterialButton>
                                {/* <MaterialButton
                                  variant="gradient"
                                  color="dark"
                                  onClick={AddDelete}
                                  startIcon={<DeleteIcon />}
                                >
                                  Delete
                                </MaterialButton> */}
                              </ButtonGroup>
                            )}
                        </Stack>
                      ) : (
                        <Stack
                          direction="row"
                          justifyContent="space-between"
                          alignItems="center"
                          spacing={2}
                        >
                          <Stack direction="column" spacing={0}>
                            <MaterialTypography
                              variant="h5"
                              fontWeight="medium"
                            >
                              Exit Form
                            </MaterialTypography>
                          </Stack>
                        </Stack>
                      )}
                    </>
                  }
                />
        <CardContent>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 7, xs: 12, sm: 7 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Reason for leaving   <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="exitReason"
                  options={reasonOptions}
                  value={exitFormData.exitReason}
                  customStyles={{ optionPadding: 20 }}
                  onChange={handleChange}
                  error={exitFormData.exitReasonStatus === "error" ? true : false}
                  success={exitFormData.exitReasonStatus === "success" ? true : false}
                  isDisabled={togglePage.view}
                />
        
              </Grid>
              <Grid size={{ lg: 5, xs: 12, sm: 5}}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Other Reason
                      </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                name="othersExitReason"
                value={exitFormData.othersExitReason}
                onChange={handleChange}
                success={exitFormData.othersExitReasonStatus === "success" ? true : false}
                error={exitFormData.othersExitReasonStatus === "error" ? true : false}
                disabled={exitFormData.exitReason?.value !== "Other" || togglePage.view}
                />
                {exitFormData.exitReason?.value !== "Other" && exitFormData.othersExitReason === ""  ? (
                  <FormControl>
                    <FormHelperText>Enter Other Reason for Leaving that is not there in the options</FormHelperText>
                  </FormControl>
                ): <FormControl sx={{visibility:"hidden"}} >
              </FormControl>}
                {exitFormData.othersExitReasonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Other Reason should be minimum 1 character and maximum 100 characters long</FormHelperText>
                  </FormControl>
                )}
              </Grid>

              <Grid size={{ lg: 7, xs: 12, sm: 7 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    If you are leaving for a new position, what makes it more attractive than the one you are leaving? <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="newJobReason"
                  value={exitFormData.newJobReason}
                  options={reason2Options}
                  onChange={handleChange}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    exitFormData.newJobReasonStatus === "error" ? true : false
                  }
                  success={
                    exitFormData.newJobReasonStatus === "success"
                  }
                  isDisabled={togglePage.view}
                />
              </Grid>
              <Grid size={{ lg: 5, xs: 12, sm: 5}}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Other
                      </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                name="othersNewJobReason"
                value={exitFormData.othersNewJobReason}
                onChange={handleChange}
                success={exitFormData.othersNewJobReasonStatus === "success" ? true : false}
                error = {exitFormData.othersNewJobReasonStatus === "error" ? true : false}
                disabled={exitFormData.newJobReason?.value !== "Other" || togglePage.view}
                />
                 {exitFormData.newJobReason?.value !== "Other" && exitFormData.othersNewJobReason === ""  ? (
                  <FormControl>
                    <FormHelperText>Enter Other Reason for New Position that is not there in the options</FormHelperText>
                  </FormControl>
                ): <FormControl sx={{visibility:"hidden"}} >
              </FormControl>}
                {exitFormData.othersNewJobReasonStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Other Reason should be minimum 1 character and maximum 100 characters long</FormHelperText>
                  </FormControl>
                )}
              </Grid>
                  {/* </TableContainer> */}
              <Grid item xs={12} sm={10} md={8}>
                <Table sx={tableStyles.table}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Characteristics</TableCell>
                      {ratings.map((rating) => (
                        <TableCell key={rating}>{rating}</TableCell>
                      ))}
                      <TableCell>Comment Box</TableCell>
                    </TableRow>

                    <TableBody>
                    {characteristics.map((char, index) => {
                      // Convert to camelCase to match selectedRatings keys
                      const charKey = char
                        .split(" ")
                        .map((word, idx) =>
                          idx === 0 ? word.toLowerCase() : word.charAt(0).toUpperCase() + word.slice(1).toLowerCase()
                        ).join("");

                      return (
                        <TableRow key={`${char}-${index}`}>
                          <TableCell>{char}</TableCell>
                          {ratings.map((rating) => (
                            <TableCell key={`${char}-${rating}`}>
                              <Checkbox
                                name={charKey}
                                value={rating}
                                disabled={togglePage.view}
                                color="primary"
                                checked={selectedRatings[charKey] === ratingValues[rating]}
                                onChange={handlefeedbback}
                              />
                            </TableCell>
                          ))}
                          <TableCell  sx={{ padding: 0, width: "400px" }}>
                            <TextField
                              name={`${charKey}`}
                              value={exitFormData[charKey] || ""}
                              onChange={handleCommentChange(charKey)}
                              size="small"
                              fullWidth
                              disabled={togglePage.view}
                              placeholder="Enter comment"
                              sx={{
                                border: "none",
                                "& .MuiInputBase-root": {
                                  borderRadius: 0,
                                  padding: "6px 12px",
                                },
                              }}
                            />
                          </TableCell>

                        </TableRow>
                      );
                    })}


                    </TableBody>
                  </TableHead>
                </Table>
              </Grid>
            </Grid> 

            <Grid marginTop={2} container spacing={2}>
            <Grid size={{ lg: 6, xs: 12, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                   Are there any additional benefits you would like to receive?  <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="additionalBenefits"
                  value={exitFormData.additionalBenefits}
                  options={benefitsOptions}
                  onChange={handleChange}
                  customStyles={{ optionPadding: 20 }}
                  error={
                    exitFormData.additionalBenefitsStatus === "error" ? true : false
                  }
                  success={
                    exitFormData.additionalBenefitsStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view}
                />
   
              </Grid>
              <Grid size={{ lg: 6, xs: 12, sm: 6}}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Other Benefits
                      </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                name="additionalBenefitsComments"
                value={exitFormData.additionalBenefitsComments}
                onChange={handleChange}
                success={exitFormData.additionalBenefitsCommentsStatus === "success" ? true : false}
                error={exitFormData.additionalBenefitsCommentsStatus === "error" ? true : false}
                disabled={exitFormData.additionalBenefits?.value!="Other" || togglePage.view}
                />
                 {exitFormData.additionalBenefits?.value !== "Other" && exitFormData.additionalBenefitsComments === ""  ? (
                  <FormControl>
                    <FormHelperText>Enter Other Benefits that is not there in the options</FormHelperText>
                  </FormControl>
                ): <FormControl sx={{visibility:"hidden"}} >
              </FormControl>}
                  {exitFormData.additionalBenefitsCommentsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText>Other Reason should be minimum 1 character and maximum 100 characters long</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Encouraged feedback from Manager <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="managerFeedback"
                  multiline
                  rows={4}
                  value={exitFormData.managerFeedback}
                  onChange={handleChange}
                  error={exitFormData.managerFeedbackStatus === "error" ? true : false}
                  success={exitFormData.managerFeedbackStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                />
                {exitFormData.managerFeedbackStatus === "error" && (
                  <FormControl error>
                    <FormHelperText> Manager Feedback can accept minimum 1 character and maximum 200 characters</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 6 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                   Explain the position and responsibilities of the job you held.   <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  name="jobResponsibilities"
                  multiline
                  rows={4}
                  value={exitFormData.jobResponsibilities}
                  onChange={handleChange}
                  error={exitFormData.jobResponsibilitiesStatus === "error" ? true : false}
                  success={exitFormData.jobResponsibilitiesStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                />
                {exitFormData.jobResponsibilitiesStatus === "error" && (
                  <FormControl error>
                    <FormHelperText> Job Responsibilities can accept minimum 1 character and maximum 200 characters</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{lg: 6, xs: 5, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                    What were some of the frustrations you experienced in the performance and execution of job responsibilities? <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                  name="frustrations"
                  value={exitFormData.frustrations}
                  onChange={handleChange}
                  error={exitFormData.frustrationsStatus === "error" ? true : false}
                  success={exitFormData.frustrationsStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  multiline
                  rows={4}
                  />
                  {exitFormData.frustrationsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText> Job Frustrations can accept minimum 1 character and maximum 200 characters</FormHelperText>
                  </FormControl>
                )}
              </Grid>
            
              <Grid size={{ lg: 6, xs: 5, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                    What changes would be required of the company? <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                  name="suggestedChanges"
                  value={exitFormData.suggestedChanges}
                  onChange={handleChange}
                  error={exitFormData.suggestedChangesStatus === "error" ? true : false}
                  success={exitFormData.suggestedChangesStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  multiline
                  rows={4}
                  />
                  {exitFormData.suggestedChangesStatus === "error" && (
                  <FormControl error>
                    <FormHelperText> Changes required can accept minimum 1 character and maximum 200 characters</FormHelperText>
                  </FormControl>
                )}
              </Grid>
              <Grid size={{ lg: 6, xs: 5, sm: 6 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                    Overall Comments <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                  name="overallComments"
                  value={exitFormData.overallComments}
                  onChange={handleChange}
                  error={exitFormData.overallCommentsStatus === "error" ? true : false}
                  success={exitFormData.overallCommentsStatus === "success" ? true : false}
                  disabled={togglePage.view === true ? true : false}
                  multiline
                  rows={4}
                  />
                   {exitFormData.overallCommentsStatus === "error" && (
                  <FormControl error>
                    <FormHelperText> Overall comments can accept minimum 1 character and maximum 200 characters</FormHelperText>
                  </FormControl>
                )}
              </Grid>
             
            </Grid>

            {/* </Radio Buttons> */}
            <Grid container spacing={2} mt={2}>
                <Grid size={{ lg: 6, xs: 12, sm: 6 }}>
                    <MaterialBox>
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold">
                        Would you be willing to stay with our company under a more satisfactory arrangement?
                      </MaterialTypography>
                    </MaterialBox>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={exitFormData.willingToStay === 'Yes'}
                          onChange={() =>
                            setExitFormData({ ...exitFormData, willingToStay: 'Yes' })
                          }
                          disabled={togglePage.view}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                        control={
                          <Checkbox
                            checked={exitFormData.willingToStay === 'No'}
                            onChange={() =>
                              setExitFormData({ ...exitFormData, willingToStay: 'No' })
                            }
                            disabled={togglePage.view}
                          />
                        }
                        label="No"
                    />
                </Grid>
                <Grid size={{lg: 6, xs: 12, sm: 6 }}>
                    <MaterialBox>
                      <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold">
                        Based on your experience with us, would you recommend our company to a friend or colleague?
                      </MaterialTypography>
                    </MaterialBox>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={exitFormData.recommendCompany === 'Yes'}
                          onChange={() =>
                            setExitFormData({ ...exitFormData, recommendCompany: 'Yes' })
                          }
                          disabled={togglePage.view}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                        control={
                          <Checkbox
                            checked={exitFormData.recommendCompany === 'No'}
                            onChange={() =>
                              setExitFormData({ ...exitFormData, recommendCompany: 'No' })
                            }
                            disabled={togglePage.view}
                          />
                        }
                        label="No"
                    />
                </Grid>
                
                <Grid size={{ lg: 6, xs: 12, sm: 12 }} >
                <Divider />
                  <MaterialBox>
                    <MaterialTypography component="label" variant="caption" fontWeight="bold">
                      Did your Manager?
                    </MaterialTypography>

                    <ul style={{ paddingLeft: "1.2rem", marginTop: "0.5rem" }}>
                      <li>
                        <MaterialTypography component="span" variant="caption" fontWeight="">
                          Demonstrated fair and equal treatment
                        </MaterialTypography>
                      </li>
                      <li>
                        <MaterialTypography component="span" variant="caption" fontWeight="">
                          Provided recognition on the job
                        </MaterialTypography>
                      </li>
                      <li>
                        <MaterialTypography component="span" variant="caption" fontWeight="">
                          Kept employees well informed
                        </MaterialTypography>
                      </li>
                      <li>
                        <MaterialTypography component="span" variant="caption" fontWeight="">
                          Made themselves available for discussions of any problems or potential problems.
                        </MaterialTypography>
                      </li>
                    </ul>
                  </MaterialBox>

                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={exitFormData.managerFeedbackComments === 'Yes'}
                          onChange={() =>
                            setExitFormData({ ...exitFormData, managerFeedbackComments: 'Yes' })
                          }
                          disabled={togglePage.view}
                        />
                      }
                      label="Yes"
                    />
                    <FormControlLabel
                        control={
                          <Checkbox
                            checked={exitFormData.managerFeedbackComments === 'No'}
                            onChange={() =>
                              setExitFormData({ ...exitFormData, managerFeedbackComments: 'No' })
                            }
                            disabled={togglePage.view}
                          />
                        }
                        label="No"
                    />
                </Grid>
            </Grid>

            {/* </TableContainer> */}
          </MaterialBox>
              <MaterialBox
                 display="flex"
                 justifyContent="flex-end"
                 alignItems="center"
               >
     
                 {/* Right side: Buttons */}
                 <MaterialBox
                   display="flex"
                   justifyContent="flex-end"
                   alignItems="center"
                   flexGrow={1}
                 >
                   {togglePage.edit === true ? (
                     <>
                       <MaterialButton
                         variant="gradient"
                         color="dark"
                         disabled={pageState.state === "submitting"}
                         onClick={handlecancel}
                       >
                         Discard
                       </MaterialButton>
                       <MaterialButton
                         sx={{ m: 2 }}
                         variant="gradient"
                         color="dark"
                         disabled={!checkAllFields1()}
                         onClick={handleEdit}
                       >
                         Update
                       </MaterialButton>
                     </>
                   ) : togglePage.view === false && togglePage.edit === false ? (
                     <>
                       <MaterialButton
                         sx={{ m: 2 }}
                         variant="gradient"
                         color="dark"
                         onClick={handlecancel}
                       >
                         Cancel
                       </MaterialButton>
                       <MaterialButton
                         variant="gradient"
                         color="dark"
                         sx={{ m: 2 ,marginLeft : "2px"}}
                         disabled={!checkAllFields1()}
                         onClick={handleAddSource}
                       >
                         Submit
                       </MaterialButton>
                     </>
                   ) : null}
                 </MaterialBox>
               </MaterialBox>
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};
export default AddExitForm;
